import { render, staticRenderFns } from "./ChildrenList.vue?vue&type=template&id=040a24aa"
import script from "./ChildrenList.vue?vue&type=script&lang=ts"
export * from "./ChildrenList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports